import React, { useState } from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'

function ConsultingField(props){
  const [icon] = useEnvValue('icons.help')
  const [str] = useEnvValue('strings.planting.consultant')
  const [consultLink] = useEnvValue('planting.consultLink')
  const [addConsulting,setAddConsulting] = useEnvValue('planting.addConsulting',false)

  const handleOnChange = function(e){
    setAddConsulting(e.target.checked)
  }

  return (

    <label>
      <input type="checkbox" name="consulting-visit" defaultChecked={addConsulting} onChange={handleOnChange}/>
      <span>{str}</span>
      {
        consultLink === null
          ? null
          : <a href={consultLink.url} target={consultLink.target}>
            <img src={icon}/></a>
      }
      </label>
  )
}

export default observer(ConsultingField)